/**
 * The poster's size and finish screens on desktop (design handoff "Taille / Finition") : a
 * "Fermer" pill top right, a title, a subtitle, four cards showing the customer's poster — its page
 * drawn without frame (shared.preview3d.PosterArtwork) — and no validation button : choosing a card
 * applies it to the creation and closes the screen. Escape closes it too. What the cards say and
 * what a choice does are the subclass' options (shared.components.PosterSizeOptions /
 * PosterFinishOptions), shared with the mobile sheet (shared.popups.PosterOptionsSheet).
 *
 * In the upsell mode (the order flow of old, still asked by fx.get("mode") == "upsell") a choice
 * raises the subclass' own next event instead of going back to the editor.
 */
fx.ns("shared.screens", class PosterBaseScreen extends fx.components.PopupPanel
{
    constructor()
    {
        super();

        this.upsell = fx.get("mode") == "upsell";
        this.mode = "";                 // no built-in exit : the screen draws its own "Fermer"
        this.destroyOnSwitch = true;
    }

    // the page drawn in pixels per mm : 420 × 600 for the 210 × 300 page, enough for a card
    get ARTWORK_RATIO() { return 2; }

    // to override : the options shown
    makeChoices()
    {
        return null;
    }

    // to override : the event a choice raises in the upsell mode
    get upsellEvent()
    {
        return "next-step";
    }

    create()
    {
        super.create();

        this.choices = this.makeChoices();
        this.view = new shared.components.PosterOptionsView({ title : this.choices.title, subtitle : this.choices.subtitle, kind : this.choices.kind });
        this.addChild(this.view, { width : "100%", height : "100%", top : 0, left : 0 });
    }

    onReady()
    {
        super.onReady();

        this.on("click", this._onClick, this.view.node);
        this.on("ESCAPE", this.close, fx.keyboard);

        this.view.cards(this.choices.cards());

        shared.preview3d.PosterArtwork.render(this, this.data, this.ARTWORK_RATIO).then((url) => {
            if (url && this.view && this.view.node)
                this.view.artwork(url);
        });

        // the card chosen at the opening has the focus : Tab and Enter work from there
        this.delay(() => this.view && this.view.focusSelected(), 50);
    }

    _onClick(e)
    {
        let target = e.target && e.target.closest ? e.target.closest("[data-action]") : null;
        if (!target || target.disabled)
            return;

        if (target.dataset.action == "close")
            return this.close();

        if (target.dataset.action == "choose")
        {
            this.view.select(target.dataset.id);
            this.choices.apply(target.dataset.id);
            this.data.event(this.upsell ? this.upsellEvent : "show-editor");
        }
    }

    close()
    {
        this.data.event("show-editor");
    }
});
